import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ConfirmationDialogComponent,
  DialogConfig,
} from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { defer, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
  private readonly _dialog = inject(MatDialog);

  public confirm(data: DialogConfig): Observable<boolean> {
    const afterClosed$ = defer(() =>
      this._dialog
        .open(ConfirmationDialogComponent, {
          data,
          disableClose: data.disableClose ?? true,
          panelClass: ['confirmation-dialog', ...(data.styles || [])],
        })
        .afterClosed(),
    );

    return afterClosed$.pipe(filter(Boolean));
  }
}
